import React from 'react';
import Icon from '../../libraries/icons';

export default function Button({ ...rest }) {
  return (
    <button
      type={rest.type || "button"}
      className={`inline-flex items-center justify-center btn ${rest.className ? rest.className : " btn-sm btn-gray"} ${(rest.submitted || rest.disabled) ? " disabled" : ""} ${rest.invert ? 'flex-row-reverse': ''}`}
      onClick={() => rest.onClick ? rest.onClick(rest.value) : null}
      disabled={rest.disabled}
    >
      {rest.icon && <Icon className={" h-4 w-4" + (rest.title ?(rest.invert ? " ml-1": " mr-1") : "")} name={rest.icon} />}
      {rest.title}
    </button>
  )
}